import { createSlice } from "@reduxjs/toolkit"

export const languageSlice = createSlice({
    name: "Language",
    initialState: {
        language: 'English',
        availableLanguages: ['English', 'French']
    },
    reducers: {
        setLanguageChoice: (state, action) => {
            state.language = action.payload
        },
    }
})

export const {
    setLanguageChoice
} = languageSlice.actions

export const selectLanguageUse = (state) => state.language.language
export const selectAvailableLanguages = (state) => state.language.availableLanguages

export default languageSlice.reducer
